// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"161":"580808da","509":"e09b2e81","759":"aaac09f9","764":"e74e1764","781":"13500087","846":"f4e3cf7f"}[chunkId] + ".js";
};